<div class="component-container">
  <div
    class="header"
    [style]="{
      backgroundColor: config().header.backgroundColor,
      backgroundImage: config().header.backgroundImage[device()] | transformUrl,
    }"
  >
    <div class="left-block">
      <img
        alt=""
        [src]="config().header.logo"
        [style.width]="config().header.logoWidth"
      />
      @if (headerV6config.dates) {
        <div
          class="campaign-dates"
          [style]="{
            color: headerV6config.dates.color,
            fontFamily: headerV6config.dates.fontFamily,
            backgroundColor: headerV6config.dates.backgroundColor,
          }"
        >
          From {{ currentCampaign().startDate | date: 'M/d' }} to
          {{ currentCampaign().endDate | date: 'M/d' }}
        </div>
      }
      <div class="campaign-caption">
        @for (label of config().header.labels; track $index) {
          <b2c-template
            [class]="label.size"
            [template]="label.text"
            [styles]="{ fontFamily: label.font }"
          />
        }
      </div>
    </div>
  </div>

  <div class="form-container" data-cy="form">
    <div class="form-wrapper">
      <div
        class="signin-bloc"
        [style.backgroundColor]="config().header.signinBloc.backgroundColor"
      >
        <b2c-template
          class="title"
          [template]="config().header.signinBloc.title.label"
          [styles]="{
            color: config().header.signinBloc.title.color,
            fontFamily: config().header.signinBloc.title.fontFamily,
          }"
        />

        @if (showErrorMessage()) {
          <div class="error" data-cy="login_error">
            {{ config().header.errorMessage }}
          </div>
        }

        <div class="form">
          <form [formGroup]="form">
            <div class="form-field mb-2 d-inline-flex flex-column w-100">
              <label class="form-label" for="form-select"
                >{{ formFieldsConfig[0].label }}
              </label>
              <select
                id="form-select"
                class="form-select"
                (ngModelChange)="onInfoTypeChanged($event)"
                [style]="formFieldsConfig[0].fieldStyles"
                [formControlName]="formFieldsConfig[0].formControlName"
              >
                @for (option of formFieldsConfig[0].options; track $index) {
                  <option [value]="option.value">
                    {{ option.label }}
                  </option>
                }
              </select>
            </div>

            <!-- Phone Number Input -->
            @if (infoType === 'phone_number') {
              <div class="form-field mb-2 d-inline-flex flex-column w-100">
                <label
                  class="form-label"
                  [for]="formFieldsConfig[1].formControlName"
                  >{{ formFieldsConfig[1].label }}
                </label>
                <input
                  b2cPhoneMask
                  data-cy="input"
                  class="form-control"
                  [type]="formFieldsConfig[1].type"
                  [id]="formFieldsConfig[1].formControlName"
                  [placeholder]="formFieldsConfig[1].placeholder"
                  [formControlName]="formFieldsConfig[1].formControlName"
                />
              </div>
            }

            <!-- Card Number Input -->
            @if (infoType === 'card_number') {
              <div class="form-field mb-2 d-inline-flex flex-column w-100">
                <label
                  class="form-label"
                  [for]="formFieldsConfig[2].formControlName"
                  >{{ formFieldsConfig[2].label }}
                </label>
                <input
                  maxlength="16"
                  minlength="11"
                  data-cy="input"
                  class="form-control"
                  [type]="formFieldsConfig[2].type"
                  [id]="formFieldsConfig[2].formControlName"
                  [placeholder]="formFieldsConfig[2].placeholder"
                  [formControlName]="formFieldsConfig[2].formControlName"
                />
                @if (
                  form.controls[formFieldsConfig[2].formControlName].invalid &&
                  (form.controls[formFieldsConfig[2].formControlName].dirty ||
                    form.controls[formFieldsConfig[2].formControlName].touched)
                ) {
                  <div class="error">
                    {{ formFieldsConfig[2].validations[0].message }}
                  </div>
                }
              </div>
            }

            <div class="tc-container">
              <b2c-checkbox
                [attr.data-cy]="
                  config().header.signinBloc.form.additionalFields[0]
                    .formControlName
                "
                [formControlName]="
                  config().header.signinBloc.form.additionalFields[0]
                    .formControlName
                "
                [label]="
                  config().header.signinBloc.form.additionalFields[0]
                    .placeholder
                "
                [labelStyles]="
                  config().header.signinBloc.form.additionalFields[0]
                    .labelStyles
                "
              />
            </div>
            <div class="form-footer">
              <b2c-button
                class="submit-btn"
                (click)="submit()"
                buttonType="submit"
                data-cy="login_button"
                [disabled]="form.invalid || formSubmitted()"
                [styles]="{
                  'border-radius': '100px',
                  color: config().header.signinBloc.form.submitButton.color,
                  fontFamily:
                    config().header.signinBloc.form.submitButton.fontFamily,
                  borderColor:
                    config().header.signinBloc.form.submitButton
                      .backgroundColor,
                  backgroundColor:
                    config().header.signinBloc.form.submitButton
                      .backgroundColor,
                }"
              >
                {{ config().header.signinBloc.form.submitButton.label }}
              </b2c-button>
            </div>
          </form>

          <div class="signup">
            <p>{{ config().header.signinBloc.signupLabel }}</p>
            <div class="signup-link">
              @let linkToCard = config().header.signinBloc.linkToCard;
              @if (linkToCard) {
                <a
                  target="_blank"
                  class="link-to-card"
                  [style]="{
                    color: linkToCard.color,
                    fontFamily: linkToCard.fontFamily,
                  }"
                  [href]="linkToCard.url"
                >
                  @if (linkToCard.icon) {
                    <img alt="" [src]="linkToCard.icon" />
                  }
                  <p>{{ linkToCard.label }}</p>
                </a>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (
    config().howToPlay.specificDisplayCondition === DISPLAY_CONDITION.ALWAYS
  ) {
    <div class="how-to-play">
      <b2c-how-to-play [enableSwipe]="true" [config]="config().howToPlay" />
    </div>
  }

  <b2c-footer />
</div>
